import { render, staticRenderFns } from "./ModalAcademyEdit.vue?vue&type=template&id=fc0d9726&scoped=true&lang=pug"
import script from "./ModalAcademyEdit.vue?vue&type=script&lang=ts"
export * from "./ModalAcademyEdit.vue?vue&type=script&lang=ts"
import style0 from "./ModalAcademyEdit.vue?vue&type=style&index=0&id=fc0d9726&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0d9726",
  null
  
)

export default component.exports